import * as React from 'react';
import { IMapGeoObject } from '@cian/frontend-newbuilding-map-component';
import { renderToStaticMarkup } from 'react-dom/server';
import { useSelector } from 'react-redux';

import { MapBalloon, MapBalloonWithRoute } from '../../../components/Map/parts';
import { getIsDistanceCalculatingEnabled } from '../../../selectors/distanceCalculating';
import { IInfrastructureItem } from '../../../types/map';

interface IUseGeoObjectBalloonParams {
  infrastructureItemsRef: React.MutableRefObject<Map<string, IInfrastructureItem>>;
  onRouteButtonClick(item: IInfrastructureItem): void;
}

export const useGeoObjectBalloon = ({ infrastructureItemsRef, onRouteButtonClick }: IUseGeoObjectBalloonParams) => {
  const isDistanceCalculatingEnabled = useSelector(getIsDistanceCalculatingEnabled);

  const handleBalloonHtmlFirstFetch = React.useCallback(
    async (geoObject: IMapGeoObject): Promise<string> => {
      const {
        name: type,
        options: { id },
      } = geoObject;

      const item = infrastructureItemsRef.current.get(id);

      if (!item) {
        return Promise.reject(new Error('Не верный тип пина!'));
      }

      const balloonProps = {
        description: String(item.timeWalk),
        routeButtonId: `route-button-${item.id}`,
        title: item.title,
        type,
      };

      const MapBallonComponent = isDistanceCalculatingEnabled ? MapBalloonWithRoute : MapBalloon;
      const markup = renderToStaticMarkup(<MapBallonComponent {...balloonProps} />);

      return Promise.resolve(markup);
    },
    [isDistanceCalculatingEnabled],
  );

  const handleBalloonOpen = React.useCallback(
    (geoObject: IMapGeoObject) => {
      const item = infrastructureItemsRef.current.get(geoObject.options.id) as IInfrastructureItem;
      const routeButton = document.getElementById(`route-button-${item.id}`);

      if (routeButton) {
        routeButton.addEventListener('click', () => {
          onRouteButtonClick(item);
        });
      }
    },
    [onRouteButtonClick],
  );

  return { onBalloonHtmlFirstFetch: handleBalloonHtmlFirstFetch, onBalloonOpen: handleBalloonOpen };
};
